import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { ContextTag } from '../wiki/Wiki'
import { GeoLayer, AbstractLayer, AbstractLayerOptions } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'

/**
 * Map layer class for the Slice DHM WMS source from Geo.
 */
class SliceDHMLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 0.5,
    depth: 0
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.SLICE_DHM,
      enabled: true,
      minZoom: 10,
      zIndex: 3
    }
    super({ ...defaultOptions, ...options })

    const { params } = options
    const opacity = params.opacity === undefined ? SliceDHMLayer.defaultParams.opacity : params.opacity
    const depth: number = params.depth === undefined ? SliceDHMLayer.defaultParams.depth : params.depth

    this.olLayer = new ol.layer.Image({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.ImageWMS({
        url: 'https://data.geo.dk/mapv2/slice-tools',
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        }),

        params: {
          layers: 'slice_dhm',
          viewparams: `model:${options.selectedGeoModel as string};depth:${depth}`,
          token: options.token
        }
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.SLICE_DHM,
      name: 'map.layer.slicedhm',
      group: LayerGroup.SUBSURFACE,
      ordering: 3,
      contextTags: [
        ContextTag.SLICE_DHM
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: true,
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geo
    }
  }
}

export default SliceDHMLayer
